import firebase from 'firebase/app';
import moment from 'moment'
// import 'firebase/auth';
// import 'firebase/analytics';

export default {
  namespaced: true,
  state: {
    foodDiary: [],
    weightDiary: [],
    deletingWeight: false,
    deletingWeightError: undefined,
    deletingFood: false,
    deletingFoodError: undefined,
    activeDate: new Date()
  },
  mutations: {
    setFoodDiary(state, payload) {
      state.foodDiary = payload;
    },
    setWeightDiary(state, payload) {
      state.weightDiary = payload;
    },
    unsubscribeFoodDiary(state, payload) {
      state.unsubscribeFoodDiary = payload
    },
    unsubscribeWeightDiary(state, payload) {
      state.unsubscribeWeightDiary = payload
    },
    deletingWeight(state, payload) {
      state.deletingWeight = payload;
    },
    deletingWeightError(state, payload) {
      state.deletingWeightError = payload;
    },
    deletingFood(state, payload) {
      state.deletingFood = payload;
    },
    deletingFoodError(state, payload) {
      state.deletingFoodError = payload;
    },
    setActivedate(state, payload) {
      state.activeDate = payload;
    },
    unsubscribeDiaryUpdates(state) {
      if (state.unsubscribeFoodDiary) {
        state.unsubscribeFoodDiary();
        state.unsubscribeFoodDiary = undefined;
      }
      if (state.unsubscribeWeightDiary) {
        state.unsubscribeWeightDiary();
        state.unsubscribeWeightDiary = undefined;
      }
    }
  },
  actions: {
    subscribeToFoodDiary({commit, rootState, state}) {      
      // Don't keep getting the data
      if (state.unsubscribeFoodDiary && state.foodDiary) {
        return;
      }
      // Unsubscribe first
      if (state.unsubscribeFoodDiary) {
        state.unsubscribeFoodDiary();
      }
      const db = firebase.firestore();
      const profileDoc = db.collection("Members").doc(rootState.User.user.id);
      const sub = profileDoc.collection('FoodDiary')
      .orderBy('c', 'desc')//.limit(5)//.get()// Just get last 5 days
      .onSnapshot(snapshot => {
        // We are not replacing the whole diary but updating it instead
        //   so that we can
        var foodDiary = [];
        snapshot.forEach(function(doc) {
          const new_doc = {
            d: doc.id,
            ...doc.data()
          }
          foodDiary.push(new_doc);
        });
        commit('setFoodDiary', foodDiary);
      },
      error => console.error(`ERROR reading diary: ${error}`));
      commit('unsubscribeFoodDiary', sub);
    },    
    subscribeToWeightDiary({commit, rootState, state}) { 
      // Don't keep getting the data
      if (state.unsubscribeWeightDiary && state.weightDiary) {
        return;
      }
      
      // Unsubscribe first
      if (state.unsubscribeWeightDiary) {
        state.unsubscribeWeightDiary();
      }
      const db = firebase.firestore();
      const profileDoc = db.collection("Members").doc(rootState.User.user.id);
      const sub = profileDoc.collection('WeightDiary')
      .onSnapshot(snapshot => {
        var weightDiary = [];
        snapshot.forEach(function(doc) {          
          // Add the weight and format it to decimal place
          weightDiary.push({ w: (doc.data().w/10), d: doc.id });
        });
        // HACK: set the current weight
        if (weightDiary.length > 0) {
          const lastWeight = (weightDiary.slice(-1)[0].w).toFixed(1);
          // Only do this if the weight's differ to save data transfer as it'll update the profile and download it all again
          if (rootState.Profile.profile.c != lastWeight) {
            commit('Profile/set_current_weight', lastWeight, { root: true } )
          }
        }

        commit('setWeightDiary', weightDiary);
      },
      error => console.error(`ERROR reading diary: ${error}`));
      commit('unsubscribeWeightDiary', sub);
    },
    deleteWeight({commit, rootState}, toDelete) {
      commit("deletingWeight", true);
      // toDelete = {"p":250,"u":"ml","g":[{"p":0.5,"i":1,"n":"Fat"}],"m":2,"n":"Milk"}
      let dayId = moment(toDelete.d).format('YYYY-MM-DD'); // Only date, time wastes space

      setTimeout(commit("deletingWeight", false), 2000) // Hack for notification
      const db = firebase.firestore();
      const profileDoc = db.collection("Members").doc(rootState.User.user.id);
      
      return profileDoc.collection('WeightDiary').doc(dayId)
      .delete()
      .catch(e => commit("deletingWeightError", e))
      .finally(() => commit("deletingWeight", false));
    },
    deleteFood({ state, rootState }, toDelete) {
      // TODO: use other than today's dates
      let dayId = moment(state.activeDate).format('YYYY-MM-DD'); // Only date, time wastes space
      const todaysFood = state.foodDiary.find(d => d.d == dayId);
      const idx = todaysFood.f.indexOf(toDelete);
      const newFood = JSON.parse(JSON.stringify(todaysFood));

      // Remove from newFood
      newFood.f.splice(idx, 1);
      delete newFood.d; // remove the date property
      const db = firebase.firestore();
      const profileDoc = db.collection("Members").doc(rootState.User.user.id);
      // Check if the food is all gone
      if (newFood.f.length == 0) {        
        return profileDoc.collection('FoodDiary').doc(dayId).delete()
      } else {
        return profileDoc.collection('FoodDiary').doc(dayId).set(newFood)
      }
    },
    addWeight({rootState}, payload) {
      const db = firebase.firestore();
      const profileDoc = db.collection("Members").doc(rootState.User.user.id);
      const dayId = moment(payload.d).format('YYYY-MM-DD');
      return profileDoc.collection('WeightDiary').doc(dayId).set({
        w: payload.w * 10 // centigram
      })
      // TODO: set the profile's current weight?  Extra data reloading entire profile :(
    }
  },
  getters: {
    foodDates(state) {
      if (state.foodDiary.length <= 0) {
        return []
      }
      return state.foodDiary.map(f => f.d);
    },
    foodEntries(state) {
      const food = state.foodDiary.find(f => moment(f.d).format('YYYY-MM-DD') == moment(state.activeDate).format('YYYY-MM-DD'));
      return food ? food.f : []
    },
    recentFoodEntries(state) {
      let food = [];
      state.foodDiary.forEach(f => {
        food = food.concat(f.f)
      });
      // Remove duplicates
      const uniquefood = food.filter((x, i, a) => {
        const ind = a.findIndex(f => f.n == x.n)
        return ind == i
      })
      return uniquefood;
    },
    foodAllowancesUsed(state, getters, rootState) {
      let result = []
      rootState.Profile.currentDiet.g.map(group => result.push({ n: group.n, a: group.a, u: 0 }));

      if (state.foodDiary.length == 0) {
        return result; // No point carrying on
      }
      
      const todaysFood = state.foodDiary.find(entry =>{
        return moment(state.activeDate).format('YYYY-MM-DD') == moment(entry.d).format('YYYY-MM-DD')
      });//moment().diff(moment(entry.d), 'days') == 0);
      
      // Add the different food groups together and calculate the progress
      if (todaysFood)
      {
        todaysFood.f.forEach(entry => {
          entry.g.forEach(fg => {
            // (food's quantity / food's portion size) * group's portion size - Food can be multiple groups of different portions sizes (2 Fat, 1 Protein)
            // 0 = free foods
            const portion = result.find(f => f.n == fg.n);
            portion.u += (entry.p == 0) ? 0 : (entry.q/entry.p)*fg.p
          })
        })
      }

      return result;
    }
  }
}